import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isBefore } from 'date-fns';

export const dateUntilAfterSinceValidator = (getSinceValue: () => string | null, required = true): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return required ? { required: { message: 'error.required_date' } } : null;
    }

    const selectedDate = new Date(control.value);
    const sinceValue = getSinceValue();
    const sinceDate = new Date(sinceValue ?? '');
    const isSinceDateValid = sinceValue && !isNaN(sinceDate.getTime());

    if (!isSinceDateValid) {
      // If "since" has no value, "until" cannot be earlier than the current date and time.
      if (isBefore(selectedDate, new Date())) {
        return { dateBeforeNow: { message: 'error.date_before_now' } };
      }
    } else {
      // If "since" is valid, "until" cannot be earlier than or equal to "since".
      if (isBefore(selectedDate, sinceDate) || selectedDate.getTime() === sinceDate.getTime()) {
        return { dateBeforeSince: { message: 'error.date_before_since' } };
      }
    }

    return null;
  };
};
